import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { InfoIcon } from '../icons';


const InfoTooltip = ({ info, id, size = '10px', className, iconFill, effect = 'float',
multiline = false }) => (<span>
  <span data-tip="React-tooltip" data-for={id} >
    <InfoIcon fill={iconFill} size={size} />
  </span>
  <ReactTooltip className={className} id={id} effect={effect} multiline={multiline}>
    <div>{info}</div>
  </ReactTooltip>
</span>
  );

InfoTooltip.propTypes = {
  info:      PropTypes.string,
  id:        PropTypes.string,
  size:      PropTypes.string,
  className: PropTypes.string,
  iconFill:  PropTypes.string,
  effect:    PropTypes.string,
  multiline: PropTypes.bool
};

export default InfoTooltip;
